import { useEffect, useState } from 'react';

/**
 * The current hook is used to get the width of an element and update it when it changes.
 * It uses the ResizeObserver API to observe the element's width.
 * More info: https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 */
export default function useElementWidth(element: HTMLElement | null): number | undefined {
  const [width, setWidth] = useState<number | undefined>();

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth((entry.target as HTMLElement).offsetWidth);
      }
    });

    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [element]);

  return width;
}
